@if(item) {
  @if (item.webUrl) {
    <a class="d-block position-relative news-item" [href]="item.webUrl" target="_blank" rel="noopener noreferrer">
      <ng-container *ngTemplateOutlet="newsItem"></ng-container>
    </a>
  }

  @else {
    <div class="news-item cursor-pointer" tabindex="0" (click)="clickNews(item.id)" (keydown.enter)="clickNews(item.id)">
      <ng-container *ngTemplateOutlet="newsItem"></ng-container>
    </div>
  }
}

<ng-template #newsItem>
  <div class="row">
    <div class="col-auto d-flex align-items-center">
      <app-news-image-avatar [imageUrl]="item.thumbnailUrl" size="xl"></app-news-image-avatar>
    </div>
    <div class="col d-flex flex-column">
      <div>
        <h3 class="news-header mb-0">{{ item.title }}</h3>
      </div>
      <div class="small">
        {{ item.excerpt }}
      </div>
      <div class="text-muted small mt-auto pt-3 d-flex align-items-end">
        <div class="align-self-end">
          {{ item.date | localisedDate: showTime ? 'E, LLL d yyyy, HH:mm' : 'E, d LLL yyyy' }}
        </div>
        <div class="vr mx-2"></div>
        <div>
          {{ item.category | newsCategory }}
        </div>
        @if (item.paywalled) {
          <div class="ms-auto" title="Paid article" data-bs-toggle="tooltip">
            <i class="fa-light fa-lock"></i>
          </div>
        }
      </div>
    </div>
    </div>
</ng-template>
